export default __webpack_public_path__ + "static/media/hamburger.4596af06.svg";